<template>
  <div class="title_wrapper fl clearfix">
    <div class="title-line fl clearfix">
      <span class="fl">{{phoneTitleObj.title}}</span>
      <div class="fl line"></div>
    </div>
    <div class="introduce_text fl" v-if="phoneTitleObj.introduction">
      {{phoneTitleObj.introduction}}
    </div>
  </div>
</template>

<script>
export default {
  // title 标题 introduction 简介
  props: {
    phoneTitleObj: {
      type: Object,
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/styles/mixin.scss';
  .title_wrapper {
    .title-line {
      position: relative;
      height: px2rem(39);
      color: #178ccf;
      font-size: px2rem(18);
      .line {
        position: absolute;
        left: 0;
        bottom: px2rem(3);
        width: px2rem(90);
        height: px2rem(3);
        background-color: #178ccf;
      }
    }
    .introduce_text {
      font-size: px2rem(14);
      line-height: px2rem(39);
      margin-left: px2rem(28);
      color: #9c9c9c;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/phonetitle.vue